import * as React from 'react';
import { Field } from 'redux-form';

import type { CompoundUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';

import CompoundInput from 'af-fields/CompoundInput';

import Preview from '../Shared/CompoundTextPreview';
import fieldHoc from '../Shared/fieldHoc';

interface OwnProps {
	disabled: boolean;
	formName: string;
	name: string;
	unit: CompoundUnitEnum;
	tooltipMessage?: React.ComponentProps<typeof CompoundInput>['tooltipMessage'];
	maxDigits?: Nullable<number>;
	onFocus?: () => void;
	onBlur?: () => void;
	onValueChange: () => void;
}

type Props = OwnProps;

const CompoundField: React.FC<Props> = (props) => {
	const {
		disabled,
		formName,
		name,
		tooltipMessage,
		unit,
		onBlur,
		onValueChange,
		onFocus,
		maxDigits,
	} = props;

	return (
		<Field
			component={CompoundInput}
			disabled={disabled}
			label={name}
			maxDigits={maxDigits}
			name={formName}
			onBlur={onBlur}
			onFocus={onFocus}
			onValueChange={onValueChange}
			tooltipMessage={tooltipMessage}
			unit={unit}
		/>
	);
};

export default fieldHoc(React.memo(CompoundField), Preview as React.FC);
